<template>
  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>退款订单</span>
      <el-button
        type="primary"
        size="small"
        class="float-right"
        @click="_toRefundOrderPage"
      >管理</el-button>
    </div>
    <div class="table-container">
      <el-table
        :data="shopOrderRefundInfo.orders"
        style="width: 100%"
        height="450"
        border
      >
        <el-table-column prop="cartId" label="订单号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="personName" label="用户名称" align="center"></el-table-column>
        <el-table-column prop="returnPayPrice" label="退款金额" align="center"></el-table-column>
        <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
        <el-table-column prop="returnReason" label="退款原因" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="_openRefundOrderDetailModel(scope.row)"
            >详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination-container"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { getRefundOrderList } from '@/api/order/shopOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopOrderRefund',
  data() {
    return {
      shopOrderRefundInfo: {
        orders: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  created() {
    this._loadShopOrderRefundData(this.pagination.currentPage, this.pagination.pageSize)
  },
  methods: {
    _openRefundOrderDetailModel(order) {
      window.open('/#/pages/goods/storeOrderCartDetail?orderId=' + order.orderId + '&cartId=' + order.cartId)
    },
    _toRefundOrderPage() {
      window.open('/#/pages/order/storeOrderCartReturn?tab=退货订单')
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._loadShopOrderRefundData(val, this.pagination.pageSize)
    },
    _loadShopOrderRefundData(page, row) {
      const shopId = getShopId()
      const params = {
        shopId: shopId,
        cartType: '3306',
        page,
        row
      }

      getRefundOrderList(params).then(res => {
        this.shopOrderRefundInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(() => {
        console.log('请求失败处理')
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.float-right {
  float: right;
}
.table-container {
  height: 450px;
  overflow-y: auto;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>